import { render, staticRenderFns } from "./ad-keyword.vue?vue&type=template&id=0b10e7f0&scoped=true&"
import script from "./ad-keyword.vue?vue&type=script&lang=js&"
export * from "./ad-keyword.vue?vue&type=script&lang=js&"
import style0 from "./ad-keyword.vue?vue&type=style&index=0&id=0b10e7f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b10e7f0",
  null
  
)

export default component.exports